import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor - attach auth headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token')
    if (token && token !== 'undefined' && token !== 'null' && token !== '') {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      // No valid token — remove stale entries
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_api_key')
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor - handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_api_key')
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export default api
